import { PropsWithChildren } from 'react';

import { cx } from 'libs/ui/theme';

import { Header, HeaderProps } from './Header';
import { LayoutStyled, LayoutStyledProps } from './Layout.styles';
import { WrapperStyled } from './Wrapper.styles';
import { LayoutClasses } from './types';

export interface LayoutProps extends LayoutStyledProps, HeaderProps {
  className?: string;
}

export const Layout = ({
  children,
  variant,
  className,
  ...headerProps
}: LayoutProps & PropsWithChildren) => (
  <LayoutStyled className={cx(LayoutClasses.main, className)} variant={variant}>
    <Header className={LayoutClasses.header} {...headerProps} />
    <WrapperStyled as="main" className={LayoutClasses.content}>
      {children}
    </WrapperStyled>
    {/* <footer className={LayoutClasses.footer} /> */}
  </LayoutStyled>
);

Layout.classes = LayoutClasses;
